import React from "react";

export const Image = ({ label, largeImage, smallImage }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        <a href={largeImage} title={label} data-lightbox-gallery="gallery1">
          <div className="hover-text">
            <h4>{label}</h4>
          </div>
          <img src={smallImage} className="img-responsive" alt={label} />{" "}
        </a>{" "}
      </div>
    </div>
  );
};
